interface ITariffFeatures {
  offlineSales: boolean
  onlineSales: boolean
  externalPercentage: boolean
}

export async function useOrgTariff(id: string) {
  const { $post } = useApi()

  const tariff = await $post<{
    percentage: {
      offline: { value: number }
      online: { value: number }
    }
    features: ITariffFeatures
  } | null>(`/api/v1/tariff/get-org-settings`, { id })

  return { tariff }
}
